import { render } from "./Benvenuto.vue?vue&type=template&id=2ca2c6f3&scoped=true"
import script from "./Benvenuto.vue?vue&type=script&lang=js"
export * from "./Benvenuto.vue?vue&type=script&lang=js"

import "./Benvenuto.vue?vue&type=style&index=0&id=2ca2c6f3&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca2c6f3"]])

export default __exports__